import React from "react";
import {
  Create,
  SimpleForm,
  TextInput,
  FileInput,
  FileField,
  BooleanInput,
  ReferenceInput,
  required,
  ArrayInput,
  SimpleFormIterator,
  AutocompleteInput,
  SelectInput,
} from "react-admin";
import { RichTextInput } from "ra-input-rich-text";
import { initialValues, ordersStatusChoices } from "../../../../utils/options";
import { PUBLIC_PROCUREMENT_ACT_PROCEDURES } from "../PublicProcurementActProcedures";
import { Grid } from "@mui/material";
import {
  arrayLabel,
  autocompleteInput_style_filter_reference,
  richTextLabel,
} from "../../../../customStyles/ra-custom-styles";
import { languageChoices } from "../../../../utils/options";
import { subjectQueryFilter } from "../../Partials/Filters";
import CustomDateInput from "common/components/Fields/CustomDateInput";

const CreatePublicProcurementActOrders = () => {
  const transform = data => ({
    ...data,
    files: data.files
      ? data.files.map(fileItem => ({
          name: fileItem.name, // Keep the name as it is
          file: fileItem.file.rawFile, // Directly use the binary file data (rawFile)
        }))
      : null,
  });
  return (
    <Create title="Създаване на поръчка">
      <SimpleForm
        defaultValues={initialValues}
        transform={transform}
      >
        <SelectInput
          label="Език"
          source="language"
          choices={languageChoices}
          validate={required()}
        />
        <TextInput
          label="Предмет на поръчката"
          source="title"
          fullWidth
          multiline
        />
        <CustomDateInput
          label="Дата на публикуване"
          source="started_on"
        />

        <TextInput
          label="АОП"
          source="agency_public_order"
        />

        <Grid
          container
          spacing={3}
        >
          <Grid
            item
            xs={12}
            sm={6}
            md={6}
          >
            <AutocompleteInput
              label="Статус"
              source="status"
              choices={ordersStatusChoices}
              fullWidth
              validate={[required()]}
              sx={autocompleteInput_style_filter_reference}
            />
          </Grid>
          <Grid
            item
            xs={12}
            sm={6}
            md={6}
          >
            <ReferenceInput
              source="procedure_id"
              reference={PUBLIC_PROCUREMENT_ACT_PROCEDURES}
            >
              <AutocompleteInput
                label="Възлагане чрез"
                optionText="name"
                fullWidth
                validate={[required()]}
                filterToQuery={subjectQueryFilter}
                sx={autocompleteInput_style_filter_reference}
              />
            </ReferenceInput>
          </Grid>
        </Grid>

        <TextInput
          label="Отговорник"
          source="accountable_person"
          fullWidth
        />
        <BooleanInput
          label="Скрита"
          source="is_hidden"
        />
        <ArrayInput
          source="files"
          label="Качете файл"
          sx={arrayLabel}
        >
          <SimpleFormIterator
            sx={{
              "& .RaSimpleFormIterator-form": {
                width: "80%",
              },
            }}
          >
            <FileInput
              placeholder="Добавете документация"
              label="Документация"
              source="file"
              maxSize={54525952}
            >
              <FileField
                source="src"
                title="title"
              />
            </FileInput>
            <TextInput
              label="Име на файла"
              source="name"
              fullWidth
            />
            <TextInput
              label="Линк"
              source="aop_link"
              validate={[required()]}
              fullWidth
            />
            <TextInput
              label="Име на линка"
              source="aop_name_link"
              fullWidth
            />
            <CustomDateInput source="publish_date" />
          </SimpleFormIterator>
        </ArrayInput>
        <RichTextInput
          sx={richTextLabel}
          label="Описание на поръчката"
          source="message"
          fullWidth
        />
        <ArrayInput
          source="order_messages"
          label="Съобщения"
          sx={arrayLabel}
        >
          <SimpleFormIterator
            fullWidth
            disableReordering
          >
            <TextInput
              label="Текст"
              source="message_title"
              fullWidth
              multiline
              validate={[required()]}
            />
            <CustomDateInput
              label="Дата"
              source="message_date"
              validate={[required()]}
            />
          </SimpleFormIterator>
        </ArrayInput>
      </SimpleForm>
    </Create>
  );
};

export default CreatePublicProcurementActOrders;
